import { businessData } from "data/businessData";
import styled from "styled-components";

export const StyledHeaderTitle = styled.h2`
  font-size: 3rem;
  line-height: 1.3;
  font-weight: 700;
  width: 100%;
  text-align: center;
  margin-bottom: 0;
  @media screen and (max-width: 1280px) {
    margin: 2rem 0 0 0;
  }
  @media screen and (max-width: 992px) {
    line-height: 1.5;
    font-size: 2.5rem;
  }
  @media screen and (max-width: 768px) {
    line-height: 1.5;
    font-size: 2rem;
    text-align: left;
  }
`;

export const StyledHeader = styled.div`
  width: 100%;
  padding: 2rem 0;
  position: relative;
  background-color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  @media screen and (max-width: 1280px) {
    height: auto;
    padding-bottom: 2rem;
  }
  * {
    color: ${(props) => props["data-dark"] && "var(--text-color)"};
  }
`;
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: calc(100% - 4rem);
  display: flex;
  padding: 4rem 0;
  gap: 3rem;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
  }
  h3 {
    font-size: 1.5rem;
    line-height: 1.3;
    color: #604aff;
  }
  h4 {
    font-size: 1.3rem;
    line-height: 1.3;
  }
`;
const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const StyledStep = styled.div`
  background-color: var(--raised-background-color);
  border-radius: 10px;
  overflow: hidden;
  flex: 1;
  border: 1px solid var(--background-color);
  flex: 0 0 400px;
  padding: 2rem;

  img {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    flex: 0 0 400px;
    max-width: 100%;
  }
`;
const StyledRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const BottomContent = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledBlock>
          <StyledHeaderTitle>{businessData.stepsTitle}</StyledHeaderTitle>
          <h3
            style={{
              color: "#604AFF",
              letterSpacing: "4px",
              marginBottom: "2rem",
              textAlign: "center",
            }}
          >
            {businessData.stepsSubtitle}
          </h3>
          <StyledRow>
            {businessData.steps.map((step) => {
              return (
                <StyledStep key={step.number}>
                  {/* eslint-disable-next-line @next/next/no-img-element*/}
                  <img src={step.image} alt={step.title} />
                  <h3>
                    {step.number}. {step.title}
                  </h3>
                  <p>{step.text}</p>
                </StyledStep>
              );
            })}
          </StyledRow>
        </StyledBlock>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default BottomContent;
